// extracted by mini-css-extract-plugin
export default {"footer":"xyX9EDdfvpvZPcgiJA8p","footer__holder":"ivbPU6qCV3eITWKD0Qew"};